import { useState } from 'react';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import PayLetterPaymentMethodSelector from '../payment/components/PayLetterPaymentMethodSelector';
import { useIdentityVerificationRedirect } from './hooks/useIdentityVerificationRedirect';

const IdentityVerificationRedirectPage = () => {
  const [isPayLetterMethodSelectorOpen, setIsPayLetterMethodSelectorOpen] = useState(false);
  const {
    hasRequiredParams,
    isSuccess,
    handleClick,
    isDuplicate,
    needsPayLetterMethodSelection,
    type
  } = useIdentityVerificationRedirect();

  if (!hasRequiredParams) return null;

  const titleText = isSuccess ? t('IdentityVerification.success') : t('IdentityVerification.fail');

  const isScene = type === 'scene';

  const imageName = () => {
    if (isSuccess) {
      if (isScene) {
        return 'shield_account';
      }
      return 'verfied.graphic';
    }
    return 'attention';
  };
  const buttonText = isSuccess ? t('next') : t('IdentityVerification.return');

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] ${isScene ? 'bg-background-dark' : 'bg-background-light dark:bg-background-dark'}`}
    >
      <img
        src={`/assets/icons/${imageName()}.png`}
        alt={imageName()}
        className={`${isScene ? 'w-[88px] h-[88px]' : 'w-[82px] h-[82px]'}`}
      />
      <h1
        className={`text-[26px] font-bold leading-[31px] whitespace-pre-line text-center mt-[40px] ${isScene ? 'text-main-dark-1' : 'text-text-main-lv1'}`}
      >
        {titleText}
      </h1>
      {isScene && isSuccess && (
        <p className="text-[15px] font-medium text-main-dark-4 text-center mt-[14px]">
          {t('IdentityVerification.goToScene')}
        </p>
      )}
      {isDuplicate && (
        <p
          className={`text-[15px] font-medium text-center mt-[14px] ${isScene ? 'text-main-dark-4' : 'text-text-main-lv4'}`}
        >
          {t('IdentityVerification.duplicated')}
        </p>
      )}
      <div
        className={`fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)] ${isScene && isSuccess ? 'opacity-0 pointer-events-none' : ''}`}
      >
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px] rounded-[18px]"
          onClick={() => {
            if (needsPayLetterMethodSelection) {
              setIsPayLetterMethodSelectorOpen(true);
              return;
            }
            void handleClick();
          }}
        >
          {buttonText}
        </Button>
      </div>
      <PayLetterPaymentMethodSelector
        isOpen={isPayLetterMethodSelectorOpen}
        onClose={() => setIsPayLetterMethodSelectorOpen(false)}
        onSelect={(paymentMethod) => {
          setIsPayLetterMethodSelectorOpen(false);
          void handleClick(paymentMethod);
        }}
      />
    </div>
  );
};

export default IdentityVerificationRedirectPage;
